import React from 'react';
const StarIcon = () => <svg className="w-3 h-3 fill-current" viewBox="0 0 24 24" data-id="element-154">
    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" data-id="element-155" />
  </svg>;
export function TestimonialsSection() {
  const testimonials = [{
    initials: 'VM',
    quote: 'Tres años en terapia girando en círculos. En una semana con este sistema identifiqué el patrón detrás de todo.',
    name: 'Valeria M.',
    details: '34 años, Buenos Aires'
  }, {
    initials: 'CR',
    quote: 'Las preguntas me llevaron a un lugar que nunca había visto. Por primera vez me entendí de verdad. Y soy psicóloga.',
    name: 'Claudia R.',
    details: '41 años, Rosario'
  }, {
    initials: 'MS',
    quote: 'Hice cursos carísimos que no me movieron. Este es diferente porque no te explica: te lleva. No es lo mismo.',
    name: 'Marcela S.',
    details: '29 años, Córdoba'
  }];
  return <section className="w-full px-4 py-6 md:py-10 bg-white" data-id="element-156">
      <div className="max-w-4xl mx-auto space-y-4" data-id="element-157">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-center text-text-main" data-id="element-158">
          Lo que dicen ellas
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-159">
          {testimonials.map((test, index) => <div key={index} className="bg-background p-4 rounded-xl shadow-sm border border-gray-100 flex flex-col" data-id="element-160">
              <div className="flex items-center gap-2 mb-2" data-id="element-161">
                <div className="w-8 h-8 bg-primary/10 text-primary font-serif font-bold rounded-full flex items-center justify-center text-sm" data-id="element-162">
                  {test.initials}
                </div>
                <div className="flex text-bonus" data-id="element-163">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} data-id="element-164" />)}
                </div>
              </div>
              <p className="text-text-main text-sm italic mb-3 flex-grow leading-snug" data-id="element-165">
                "{test.quote}"
              </p>
              <div className="pt-2 border-t border-gray-200" data-id="element-166">
                <p className="font-bold text-text-main text-xs" data-id="element-167">{test.name}</p>
                <p className="text-[11px] text-text-muted" data-id="element-168">{test.details}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}